export function LinkConditioner() {
    $('a').each(() => {
        let link = $(this).attr('href');

        // Go no further if this is not a link
        if (!link)
            return;

        let internal = $(this).hasClass('link-internal');
        let dropdown = $(this).hasClass('dropdown-menu');
        let menusItem = $(this).hasClass('dropdown-item');
        let jsClick = link === 'javascript:void(0)';
        let isPdf = link.substr(link.lastIndexOf('.') + 1) === 'pdf';

        $(this).attr('target', () => {
            if (internal || dropdown || menusItem || jsClick || (<HTMLAnchorElement>this).host == location.host) {
                if (!isPdf)
                    return '_self'
            } else
                return '_blank';
        });

        //SEO stuff, avoid PageRank penalty
        $(this).attr('rel', () => {
            if (internal || jsClick || (<HTMLAnchorElement>this).host == location.host)
                return
            else
                return 'nofollow';
        })
    });

    $('a[href^="mailto:"]').each((i, el) => {
        $(el).removeAttr('target');
        $(el).attr('target', () => { return '_self' });
    })
};

export function TestimonialShortener() {
    // Testimonials text-truncate
    $('.testimonial-comment').each(() => {
        if ($(this).text().length > 250) {
            let text = $(this).text()
            text = text.substr(0, 250) + '...';
            $(this).text(text);
        }
    })
}